'use client';
import React from 'react';

import Link from 'next/link';

export default function BlogBottomPagination({
  pageFrom,
  pageTo,
  totalHits,
  currentPage,
  searchQuery,
  numberOfPages,
  tag,
  searchFilters,
  overrideUrl,
}: {
  pageFrom: number;
  pageTo: number;
  totalHits: number;
  currentPage: number;
  searchQuery: string;
  numberOfPages: number;
  tag: string;
  searchFilters?: {
    category: string | null;
    tag: string | null;
  };
  overrideUrl?: string;
}) {
  const baseUrl = overrideUrl || '/blog/search';
  return (
    <>
      <div className='flex w-full flex-col items-center justify-between gap-8 border-t border-t-gray-300 pt-6 sm:flex-row sm:items-start md:gap-9'>
        <span className='text-center font-sans text-base text-charcoal-400 sm:text-left'>
          Showing {pageFrom} to {pageTo} of {totalHits} {tag}
        </span>
        {!!totalHits && (
          <div className='flex justify-between gap-2'>
            {currentPage !== 1 ? (
              <Link
                prefetch={true}
                href={{
                  pathname: baseUrl,
                  query: {
                    ...(currentPage > 1 && { page: currentPage - 1 }),
                    ...(searchQuery && { query: searchQuery }),

                    ...(searchFilters?.category && {
                      category: searchFilters.category,
                    }),
                    ...(searchFilters?.tag && { tag: searchFilters.tag }),
                  },
                }}
                className={`cursor-pointer rounded-[10px] border border-[#EFE9DB] bg-[#F9F6F0] px-14 py-4 text-lg hover:border hover:border-[#FFCD00] hover:bg-gradient-to-r hover:from-[#FFCF41] hover:to-[#FFE283] sm:px-5 sm:py-2 sm:text-base ${currentPage === 1 ? '!cursor-not-allowed' : ''}`}
              >
                Previous
              </Link>
            ) : (
              <div
                className={`cursor-pointer rounded-[10px] border border-[#EFE9DB] bg-[#F9F6F0] px-14 py-4 text-lg hover:border hover:border-[#FFCD00] hover:bg-gradient-to-r hover:from-[#FFCF41] hover:to-[#FFE283] sm:px-5 sm:py-2 sm:text-base ${currentPage === 1 ? '!cursor-not-allowed' : ''}`}
              >
                Previous
              </div>
            )}

            {currentPage < numberOfPages ? (
              <Link
                prefetch={true}
                href={{
                  pathname: baseUrl,
                  query: {
                    ...(currentPage < numberOfPages && {
                      page: currentPage + 1,
                    }),
                    ...(searchQuery && { query: searchQuery }),

                    ...(searchFilters?.category && {
                      category: searchFilters.category,
                    }),
                    ...(searchFilters?.tag && { tag: searchFilters.tag }),
                  },
                }}
                className={`cursor-pointer rounded-[10px] border border-[#EFE9DB] bg-[#F9F6F0] px-14 py-4 text-lg hover:border hover:border-[#FFCD00] hover:bg-gradient-to-r hover:from-[#FFCF41] hover:to-[#FFE283] sm:px-5 sm:py-2 sm:text-base ${currentPage === numberOfPages ? '!cursor-not-allowed' : ''}`}
              >
                Next
              </Link>
            ) : (
              <div
                className={`cursor-pointer rounded-[10px] border border-[#EFE9DB] bg-[#F9F6F0] px-14 py-4 text-lg hover:border hover:border-[#FFCD00] hover:bg-gradient-to-r hover:from-[#FFCF41] hover:to-[#FFE283] sm:px-5 sm:py-2 sm:text-base ${currentPage === numberOfPages ? '!cursor-not-allowed' : ''}`}
              >
                Next
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
